import { QualificationCategoryV2 } from './QualificationCategoryV2';
import {
  QualificationTrainingProviderType,
  QualificationTrainings,
} from './QualificationTrainings';
import { QualificationV2 } from './QualificationV2';

export type QualificationId = { id: string };

export interface GetTrainingQualificationsParams {
  pageNumber: number;
  pageSize: number;
  relations: string[];
  userIds?: string[];
  qualificationIds?: string[];
  organizationalUnitId?: string[];
  status?: string[];
  search?: string;
  lang: string;
  order?: Record<string, 'asc' | 'desc'>;
}

export interface TrainingQualificationsResponse {
  data: QualificationTrainings[];
  pagination: {
    totalRecords: number;
    currentPage: number;
    pageSize: number;
    numberOfPages: number;
  };
}

export interface TrainingsQualificationsWithRelationsResponse {
  data: QualificationTrainings[];
  pagination: {
    totalRecords: number;
    currentPage: number;
    pageSize: number;
    numberOfPages: number;
  };
}

export interface BulkCreateTrainingQualificationDto
  extends CreateTrainingQualificationDto {
  provider: QualificationTrainingProvider | null;
}

export interface CreateTrainingQualificationDto {
  userId: string;
  name: string;
  notes: string | null;
  labels?: Array<{ id: string }> | null;
  organizationalUnitQualificationTrainingProviderId: string | null;
  qualifications: Array<{ id: string }> | null;
  routeParts?: string[] | null;
}

export interface QualificationTrainingProvidersResponse {
  data: QualificationTrainingProvider[];
  pagination: {
    totalRecords: number;
    currentPage: number;
    pageSize: number;
    numberOfPages: number;
  };
}

export interface QualificationTrainingProviderCourse {
  id: string;
  name: string;
}

export interface QualificationTrainingProviderCoursesResponse {
  data: QualificationTrainingProviderCourse[];
  pagination: {
    totalRecords: number;
    currentPage: number;
    pageSize: number;
    numberOfPages: number;
  };
}

export interface QualificationTrainingProviderClass {
  id: string;
  name: string;
  description: string;
  qualifications: QualificationWithCategory[];
}

type QualificationWithCategory = Pick<
  QualificationV2,
  'id' | 'nameDe' | 'nameEn' | 'namePl' | 'nameFr'
> & {
  qualificationCategory: Pick<
    QualificationCategoryV2,
    'id' | 'nameDe' | 'nameEn' | 'namePl' | 'nameFr'
  >;
};

export interface QualificationTrainingProvider {
  id: string | null;
  authToken: string | null;
  name: string;
  qualificationTrainingProviderClasses: QualificationTrainingProviderClass[];
  description: string;
  logoUrl: string;
  organizationalUnitQualificationTrainingProviders: {
    id: string;
    approvalStatus: OrganizationalUnitQualificationTrainingProviderApprovalStatus;
  }[];
  providerType: string;
  websiteUrl: string;
  email: string;
  providerIdentifier?: string;
}

export interface TrainingQualificationRow {
  provider: QualificationTrainingProvider | null;
  class: QualificationTrainingProviderClass | null;
  qualifications: string[] | null;
  routeParts?: string[] | null;
}

export interface GetTrainingProvidersParams {
  pageNumber: number;
  pageSize: number;
  order?: Record<string, 'asc' | 'desc'>;
  searchText?: string;
  approvalStatuses?: OrganizationalUnitQualificationTrainingProviderApprovalStatus[];
  providerTypes?: QualificationTrainingProviderType[];
  qualificationIds?: string[];
}

export enum OrganizationalUnitQualificationTrainingProviderApprovalStatus {
  Accepted = 'accepted',
  Declined = 'declined',
}

export interface OrganizationalUnitQualificationTrainingProvider {
  approvalStatus: OrganizationalUnitQualificationTrainingProviderApprovalStatus;
  id: string;
}
